<template>
    <div class="header">

        <div :class="['header-nav', 'header-fixed']">
            <span></span>

            <div class="tool-wrap tool-wrap-light">
                <i class="iconfont icon-xiaochengxufenxiang" @click="share"></i>
                <i class="line"></i>
                <i class="iconfont icon-xiaochengxu-guanbi" @click="goBack"></i>
            </div>
        </div>

        <div :class="['header-nav', 'header-abs']" :style="opacityStyle">

            <span>吴兴区汽车消费券</span>

            <div class="tool-wrap tool-wrap-deep">
                <i class="iconfont icon-xiaochengxufenxiang" @click="share"></i>
                <i class="line"></i>
                <i class="iconfont icon-xiaochengxu-guanbi" @click="goBack"></i>
            </div>
        </div>

    </div>
</template>

<script>
// import SignCard from "@/components/SignCard";
import { shareData } from "@/utils/common";

export default {
    props: {
        scrollTop: Number,
        goodsInfo: Object,
    },
    components: {
        // SignCard,
    },
    data() {
        return {
            show: false,
            showAbs: true,
            opacityStyle: {
                opacity: 0,
            },
            opacity2Style: {
                opacity: 1,
            },
            shareData,
            

        };
    },
    watch: {
        scrollTop() {
            let opacity = this.scrollTop / 140;
            opacity = opacity > 1 ? 1 : opacity;

            if (this.scrollTop > 20) {
                this.opacityStyle = { opacity };
            } else {
                this.opacityStyle = { opacity: 0 };

                // if (this.scrollTop > 40) {
                //   this.opacityStyle = { opacity };
                // }
            }
        },
    },
    methods: {
        goBack() {
            SmartCity.goBack();
        },
        share() {

            console.log(this.shareData);
            SmartCity.shareTo({
                title: this.shareData.title,
                contentURL: this.shareData.link,

                brief: "等你来参与",
                imageLink:
                    this.shareData.imgUrl,
            });
        },
    },
    mounted() {},
};
</script>

<style lang="less" scoped>
.header {
    width: 100%;

    .header-nav {
        position: fixed;

        top: 0;
        left: 0;
        right: 0;
        height: 80px;
        padding-bottom: 10px;

        color: #333;
        font-size: 16px;
        text-align: center;
        z-index: 100;
        display: flex;

        justify-content: center;
        align-items: flex-end;
        text-align: center;
        span {
            font-size: 18px;
            // margin-left: 20px;
        }
    }
    .header-abs {
        background: transparent;
        background: #002981;

        color: #fff;
        // box-shadow: @shadow;
    }

    .header-fixed {
        // box-shadow: @shadow;

        // background: #fff;
    }

    .tool-wrap {
        display: flex;
        align-items: center;
        padding: 0 10px;
        height: 30px;
        line-height: 30px;
        position: absolute;
        right: 20px;
        top: 42px;

        color: #333;
        font-size: 16px;
        border-radius: 20px;
        text-align: center;

        z-index: 100;
        // border: 1px solid #f2f2f2;

        .line {
            height: 14px;
            margin: 2px 10px;
        }

        i:nth-child(1) {
            font-size: 20px;
        }
    }
    .tool-wrap-light {
        background: rgba(255, 255, 255,.4);
        color: #333;

        // border: 1px solid #f2f2f2;

        .line {
            border-right: 1px solid rgba(255, 255, 255,.4);
        }
    }

    .tool-wrap-deep {
        background: rgba(0, 0, 0, 0.4);

        color: #fff;
        border: 1px solid rgba(0, 0, 0, 0);

        .line {
            border-right: 1px solid #eee;
        }
    }
}
</style>
